module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-credit-records"
  }, [_c('ActionBar', [_c('h2', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("Packets")])]), _c('base-list', {
    attrs: {
      "component": _vm.component,
      "dataLoader": _vm.dataLoader,
      "resultsPerPage": 5,
      "componentType": "listing"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6570d04e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/PacketRecords.vue
// module id = 2394
// module chunks = 1